//#region imports
import { OnlyNumberDirective } from './directives/only-numbers';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { PreviousComponent } from 'src/app/shared/components/previous/previous.component';
import { NextComponent } from 'src/app/shared/components/next/next.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { DialogComponent } from './components/dialogs/dialog/dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatSnackBarModule, MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SaveDialogComponent } from './components/dialogs/save-dialog/save-dialog.component';
import { SaveConfirmationDialogComponent } from './components/dialogs/save-confirmation-dialog/save-confirmation-dialog.component';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { ContactInformationDialogComponent } from './components/dialogs/contact-information-dialog/contact-information-dialog.component';
import { SupportDialogComponent } from './components/dialogs/support-dialog/support-dialog.component';
import { InformationDialogComponent } from './components/dialogs/information-dialog/information-dialog.component';
import { RecallDialogComponent } from './components/dialogs/recall-dialog/recall-dialog.component';
import { SendDialogComponent } from './components/dialogs/send-dialog/send-dialog.component';
import { SendConfirmationDialogComponent } from './components/dialogs/send-confirmation-dialog/send-confirmation-dialog.component';
import { RecallConfirmationDialogComponent } from './components/dialogs/recall-confirmation-dialog/recall-confirmation-dialog.component';
import { ServerFailErrorComponent } from './components/server-fail-error/server-fail-error.component';
import { BrowserSupportComponent } from './components/browser-support/browser-support.component';
import { PhoneNumberValidatorDirective } from './directives/phone-number-validator.directive';
import { PostalCodeValidatorDirective } from './directives/postal-code-validator.directive';
import { CustomSpinnerComponent } from './components/custom-spinner/custom-spinner.component';
//#endregion

@NgModule({
    declarations: [
        PreviousComponent, NextComponent,
        HeaderComponent, FooterComponent,
        DialogComponent,
        CustomSpinnerComponent,
        SaveDialogComponent,
        SaveConfirmationDialogComponent,OnlyNumberDirective, ContactInformationDialogComponent, 
        SupportDialogComponent, InformationDialogComponent, RecallDialogComponent, RecallConfirmationDialogComponent,
        SendDialogComponent, SendConfirmationDialogComponent, ServerFailErrorComponent, BrowserSupportComponent, PhoneNumberValidatorDirective, PostalCodeValidatorDirective
    ],
    providers: [DecimalPipe],
    imports: [
        CommonModule, MatSnackBarModule, MatDialogModule,
        TooltipModule.forRoot(), TranslateModule,FormsModule,
        NgCircleProgressModule.forRoot({
            backgroundColor: '#ffffff',
            radius: 10,
            maxPercent: 100,
            outerStrokeWidth: 20,
            outerStrokeColor: '#ee8007',
            outerStrokeLinecap: 'butt',
            showTitle: false,
            showSubtitle: false,
            showUnits: false,
            showInnerStroke: false,
            startFromZero: false,
            animation: true,
            animationDuration: 500,
            backgroundPadding: 0
        }), 
        ProgressbarModule.forRoot()
    ],
    entryComponents: [
        DialogComponent,SaveDialogComponent,SaveConfirmationDialogComponent,
        SupportDialogComponent,InformationDialogComponent,ContactInformationDialogComponent,
        RecallDialogComponent,RecallConfirmationDialogComponent,
        SendDialogComponent,SendConfirmationDialogComponent, ServerFailErrorComponent],
    exports: [
        DialogComponent, PreviousComponent, NextComponent,
        HeaderComponent, FooterComponent,
        TranslateModule, TooltipModule, NgCircleProgressModule,OnlyNumberDirective,BrowserSupportComponent
    ]
})
export class SharedModule { }

